

















import {
  Component, Emit, Prop, Vue,
} from 'vue-property-decorator';

@Component
export default class MenuFab extends Vue {
  @Prop(String) readonly color: string | undefined;

  @Prop(String) readonly icon: string | undefined;

  @Prop(String) readonly tooltip: string | undefined;
}
